import produce from "immer"
import { initUser } from "client/store"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initUserProfileState: types.UserProfileState = {
    profileView: initUser,
    profileEdit: initUser,

    reloadView: true,
    reloadEdit: true,
}

const userProfileReducer = produce((
    draft: types.UserProfileState = initUserProfileState,
    action: ActionTypes = null,
): types.UserProfileState => {
    switch (action.type) {
        case types.USER_PROFILE_VIEW:
            draft.profileView = action.profile
            return draft

        case types.USER_PROFILE_EDIT:
            draft.profileEdit = action.profile
            return draft

        case types.USER_PROFILE_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.USER_PROFILE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default userProfileReducer
